export default "__VITE_ASSET__bb4c3027__"